module.exports = __webpack_public_path__ + "img/psn.dc18fd55.svg";